"use client"

import { createContext, useContext, ReactNode } from "react"

type PermissionContextType = {
  has: (permission: string) => boolean
}

const PermissionContext = createContext<PermissionContextType>({
  has: () => false
})

export function PermissionProvider({
                                     permissions,
                                     children
                                   }: {
  permissions: string[]
  children: ReactNode
}) {

  const permissionSet = new Set(permissions)

  const has = (permission: string) => {
    // if (permissionSet.has("*")) return true // admin wildcard
    return permissionSet.has(permission)
  }

  return (
    <PermissionContext.Provider value={{ has }}>
      {children}
    </PermissionContext.Provider>
  )
}

export function usePermission() {
  return useContext(PermissionContext)
}
